export default function Chip(props: { children: any }) {
  return (
    <div className="bg-background-neutral px-3 py-1 text-sm rounded-full text-gray-700">
      {props.children}
    </div>
  );
}
